import React from "react";

const ListenerHistoryTab: React.FC = () => {
    return (
        <div className="rounded-3xl border border-gray-100 bg-white p-8 shadow-md">
            <h2 className="text-lg font-semibold text-gray-800">
                История действий
            </h2>

            <p className="mt-2 text-sm text-gray-500">
                Здесь позже будет журнал: регистрация, выдача программ, изменения данных, сообщения, выпуск и отправка диплома.
            </p>
        </div>
    );
};

export default ListenerHistoryTab;